import { $axios, apiList } from '@/api'

export default {
    actions: {
        getChatInfoByCourseId(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.yandex.getChatInfo.method,
                    params: {
                        wsfunction: apiList.yandex.getChatInfo.moodle_method,
                        coursemoduleid: payload
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(err => reject(err))
            })
        }
    }
}